/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  // Boards
  getBoards(params = {}) {
    return axios.get(`${this.url}/boards`, { params });
  }

  getBoard(boardId) {
    return axios.get(`${this.url}/boards/${boardId}`);
  }

  createBoard(data) {
    return axios.post(`${this.url}/boards`, data);
  }

  updateBoard(boardId, data) {
    return axios.put(`${this.url}/boards/${boardId}`, data);
  }

  deleteBoard(boardId) {
    return axios.delete(`${this.url}/boards/${boardId}`);
  }

  toggleFavorite(boardId) {
    return axios.post(`${this.url}/boards/${boardId}/toggle_favorite`);
  }

  updateBoardAgents(boardId, agentIds) {
    return axios.post(`${this.url}/boards/${boardId}/update_agents`, {
      agent_ids: agentIds,
    });
  }

  updateBoardInboxes(boardId, inboxIds) {
    return axios.post(`${this.url}/boards/${boardId}/update_inboxes`, {
      inbox_ids: inboxIds,
    });
  }

  getBoardConversations(boardId, params = {}) {
    return axios.get(`${this.url}/boards/${boardId}/conversations`, {
      params,
    });
  }

  // Steps
  getSteps(boardId) {
    return axios.get(`${this.url}/boards/${boardId}/steps`);
  }

  createStep(boardId, step) {
    return axios.post(`${this.url}/boards/${boardId}/steps`, { step });
  }

  updateStep(boardId, stepId, step) {
    return axios.put(`${this.url}/boards/${boardId}/steps/${stepId}`, {
      step,
    });
  }

  deleteStep(boardId, stepId) {
    return axios.delete(`${this.url}/boards/${boardId}/steps/${stepId}`);
  }

  // Tasks
  getTasks(params = {}) {
    return axios.get(`${this.url}/tasks`, { params });
  }

  getTask(taskId) {
    return axios.get(`${this.url}/tasks/${taskId}`);
  }

  createTask(task) {
    return axios.post(`${this.url}/tasks`, { task });
  }

  updateTask(taskId, task) {
    return axios.put(`${this.url}/tasks/${taskId}`, { task });
  }

  deleteTask(taskId) {
    return axios.delete(`${this.url}/tasks/${taskId}`);
  }

  moveTask(taskId, boardStepId, insertBeforeTaskId = null) {
    return axios.post(`${this.url}/tasks/${taskId}/move`, {
      board_step_id: boardStepId,
      insert_before_task_id: insertBeforeTaskId,
    });
  }

  // Products
  getProducts(boardId, params = {}) {
    return axios.get(`${this.url}/boards/${boardId}/products`, { params });
  }

  createProduct(boardId, product) {
    return axios.post(`${this.url}/boards/${boardId}/products`, { product });
  }

  updateProduct(boardId, productId, product) {
    return axios.put(`${this.url}/boards/${boardId}/products/${productId}`, {
      product,
    });
  }

  deleteProduct(boardId, productId) {
    return axios.delete(`${this.url}/boards/${boardId}/products/${productId}`);
  }

  // Task products
  getTaskProducts(taskId) {
    return axios.get(`${this.url}/tasks/${taskId}/products`);
  }

  createTaskProduct(taskId, taskProduct) {
    return axios.post(`${this.url}/tasks/${taskId}/products`, {
      task_product: taskProduct,
    });
  }

  updateTaskProduct(taskId, taskProductId, taskProduct) {
    return axios.put(`${this.url}/tasks/${taskId}/products/${taskProductId}`, {
      task_product: taskProduct,
    });
  }

  deleteTaskProduct(taskId, taskProductId) {
    return axios.delete(
      `${this.url}/tasks/${taskId}/products/${taskProductId}`
    );
  }
}

export default new KanbanAPI();
